import { Popup, type SidebarNavSpaceItem, SpaceIcon } from "@design";
import { cloneElement, type ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { usePopupLabels } from "@/components/designLabels";

/** Hover flyout for a sidebar space: jump to its sections or start a chat. */
export function SpacePopup({ space, trigger }: Readonly<{ space: SidebarNavSpaceItem; trigger: ReactElement }>) {
  const { t } = useTranslation("shell", { keyPrefix: "spacePopup" });
  const labels = usePopupLabels();
  const navigate = useNavigate();
  const base = `/spaces/${space.key}`;
  return (
    <Popup
      spaceName={space.name}
      labels={labels}
      icon={
        space.private ? (
          cloneElement(space.icon, { size: 13 })
        ) : (
          <SpaceIcon icon={space.icon} hue={space.hue ?? 275} size="sm" />
        )
      }
      onOpenOverview={() => navigate(base)}
      onOpenChats={() => navigate(`${base}/chats`)}
      onOpenKnowledge={() => navigate(`${base}/knowledge`)}
      onNewChat={() => navigate("/chat")}
      askLabel={t("ask", { name: space.name })}
      onAsk={() => navigate("/chat")}
    >
      {trigger}
    </Popup>
  );
}

export const renderSpacePopup = (space: SidebarNavSpaceItem, trigger: ReactElement) => (
  <SpacePopup space={space} trigger={trigger} />
);
